














































import Vue from 'vue';
// import * as firebase from '@/plugins/firebase';
import { firebase } from 'mostra';

export type DataType = {
  email: string;
  password: string;
  phoneNumber: string;
}
export default Vue.extend({
  name: 'setting-auth-signin',
  data(): DataType {
    return {
      email: '',
      password: '',
      phoneNumber: '',
    };
  },
  methods: {
    async onClickEmail() {
      try {
        this.$loading(true);
        await firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password);
        this.$success('サインインしました Sign-in successful.');
        window.location.reload();
      } catch (error: any) {
        this.$error('サインインに失敗しました Sign-in failed.', error);
      } finally {
        this.$loading(false);
      }
    },
  },
});
